import React from 'react';

// TopHeader Area
const TopHeader = () => {
  return (
    <>
      <div className="top-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <ul className="left-info">
                <li>
                  <a href="mailto:info@trailer53.com">
                    <i className="far fa-envelope"></i>
                    info@trailer53.com
                  </a>
                </li>
                <li>
                  <a href="tel:+1 (954) 666-5152">
                    <i className="fas fa-phone-volume"></i>
                    +1 (954) 666-5152
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              {/*<ul className="right-info">
                <li className="mr-20">
                  <Link to="/login">Login</Link>
                </li>
                <li className="mr-20">
                  <Link to="/track_ship">Register</Link>
                </li>
              </ul>*/}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopHeader;
